import styled from 'styled-components'
import { theme } from '@/client/components'
import font from '@/client/components/theme/font'
const { color, space, borders, breakpoint } = theme

export const Summary = styled.div`
  padding-top: ${space.xl};
  padding-left: ${space.xs};
  padding-right: ${space.xs};

  &:not(:last-of-type) {
    padding-bottom: ${space.md};
    border-bottom: ${borders.sizes.md} dashed ${color.grayscale.light};
  }

  @media (min-width: ${breakpoint.lg}) {
    padding-top: ${space.md};
    padding-left: ${space.lg};
    padding-right: ${space.lg};
  }
`

export const SummaryHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: ${space.md};
`

export const SummaryBody = styled.div`
  width: 100%;
  padding: ${space.xs} ${space.lg};
  border-radius: ${borders.radius.lg};
  background-color: ${color.grayscale.light};
`

export const MainSummary = styled.div`
  display: block;
  @media (min-width: ${breakpoint.lg}) {
    display: flex;
    justfy-content: space-between;
  }
`

export const ShortSummary = styled.div`
  position: relative;
  left: -3.5rem;
`

export const DetailedSummary = styled.div`
  column-count: 2;
`
export const PositionSvg = styled.div`
  position: relative;
`

export const PositionTextInSvg = styled.div`
  position: absolute;
  top: 2.5rem;
  left: 6rem;
  right: 1.8rem;
  max-width: 190px;
`
export const IconAligner = styled.div`
  display: flex;
`
export const Production = styled.div`
  display: flex;
  gap: ${space.lg};
  flex-wrap: wrap;
  margin-bottom: ${space.lg};
  @media (min-width: ${breakpoint.md}) {
    flex-wrap: nowrap;
  }
`
export const ProductionType = styled.div<{ selected: boolean; disabled?: boolean }>`
  display: block;
  width: 100%;
  padding: 1.5rem ${space.xs} ${space.xs} ${space.xs};
  border-radius: ${space.md};
  opacity: ${(p) => (p.disabled ? 0.3 : 1)};
  border: ${({ selected }) =>
    selected
      ? `${borders.sizes.md} solid ${color.primary.darker}`
      : `${borders.sizes.sm} solid ${color.primary.lightPale}`};

  img,
  .icon {
    display: none;
  }

  & .icon.super-express-production-icon-main {
    &:before {
      color: #df3800;
    }
  }
  & .icon.icon-express-production-min {
    &:before {
      color: #ffa706;
    }
  }
  & .icon.standard-icon {
    &:before {
      color: #0292c2;
    }
  }

  @media (min-width: ${breakpoint.md}) {
    width: calc(100% / 3);
    position: relative;
    display: flex;
    padding: 1.5rem 0 ${space.md} ${space.md};
    img {
      display: block;
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .icon {
      display: block;
    }
    .standard-icon {
      position: relative;
    }
  }

  & .production-type-text-block {
    & span {
      display: inline-block;
      &:first-child {
        width: 100%;
      }
      &:last-child {
        margin: 0.2rem 0;
        font-size: 0.6rem;
      }
    }
  }
`
export const ProductionTypeWrapper = styled.div`
  padding: 0 0.5rem;
`
export const ProductionTypeHeader = styled.div`
  min-height: 1.5rem;
  & span {
    font-size: ${font.size.small};
  }
`
